module.exports = __webpack_public_path__ + "img/1.82c02c5f.png";